import { getServerFriendlyCookieValue } from 'features/cookies'
import { getOneUser } from '../../../__legacy__/api/v2/UsersAPI'
import { IProfile } from '../../stores/registry/ProfileRegistry'

export const userIsLoggedIn = (user: IProfile): boolean => {
  return user !== null && user !== undefined
}

export const getCurrentUser = async () => {
  // TODO: change to using useWeb3React to get the walletAddress, would need to refactor code to be hooks
  const wallet_address = await getCurrentWalletAddress()

  if (wallet_address === null) return null

  return getOneUser(wallet_address)
}

export const getCurrentWalletAddress = async (): Promise<string> => {
  // TODO: make this get the wallet even if the cookie is null
  const walletFromCookie = getServerFriendlyCookieValue('current_wallet')
  if (walletFromCookie) return walletFromCookie
  return null
}
